/**
 * /login — Business Web. The screen is `SignInView` (@tonnie/account); what is
 * Business's own comes from BUSINESS_ACCOUNT_PORTAL (../account-portal.tsx).
 */
import { SignInView } from '@tonnie/account';

export default function LoginPage() {
  return <SignInView />;
}
